import mLogo from "./logo/logo.svg";
import favicon from "./logo/favicon.svg";
import tab from "./tab.svg";
// import { ReactComponent as mTimeline } from "./icons/timeline.svg";

// LOGO
export const LogoSVG = mLogo;
export const LogoIcon = favicon;
export const TabSVG = tab;
